import { ReactNode } from "react";
import { DEFAULT_BRAND } from "../theme/brandTheme";

interface HighlightWrapperProps {
  children: ReactNode;
  isHighlighted: boolean;
  color?: string;
  className?: string;
}

export function HighlightWrapper({
  children,
  isHighlighted,
  color = DEFAULT_BRAND.primary,
  className = "",
}: HighlightWrapperProps) {
  if (!isHighlighted) {
    return <>{children}</>;
  }

  // Convert hex color to RGB for alpha transparency
  const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : { r: 124, g: 58, b: 237 }; // Fallback to purple
  };

  const rgb = hexToRgb(color);
  const rgbaString = `${rgb.r}, ${rgb.g}, ${rgb.b}`;

  return (
    <div className={`relative ${className}`}>
      {/* Subtle highlight border with spacing */}
      <div
        className="absolute -inset-2 rounded-lg pointer-events-none animate-pulse"
        style={{
          border: `3px dashed rgba(${rgbaString}, 0.4)`,
          boxShadow: `0 0 20px rgba(${rgbaString}, 0.2)`,
        }}
      />
      {children}
    </div>
  );
}
